import 'babel-polyfill'
import promise from 'es6-promise'
import Vue from 'vue'
import Element from 'element-ui'
import App from '@/App'
import i18n from '@/i18n'
import router from '@/router'
import store from '@/store'
import '@/icons'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/scss/aui.scss'
import { request } from '@/utils/request'
import {getLocalStorage, getStorage, removeStorage, setLocalStorage, setStorage} from '@/utils/storage'
import {clearLoginInfo, hasPermission} from '@/utils'
import cloneDeep from 'lodash/cloneDeep'
import global_ from './components/tool/global'
import {validate} from '@/utils/validate'
import 'swiper/dist/css/swiper.css'

import FullCalendar from 'fullcalendar'
import 'fullcalendar/dist/fullcalendar.min.css'
import 'fullcalendar/dist/locale/zh-cn.js'
import '@/utils/filter_utils'
import VueUeditorWrap from 'vue-ueditor-wrap' // ES6 Module
import echarts from 'echarts'

// 右键菜单
import EVueContextmenu from 'e-vue-contextmenu'

//富文本 2021-02-04注释
// import tinymce from 'tinymce'
// import VueTinymce from '@packy-tang/vue-tinymce'
// Vue.prototype.$tinymce = tinymce // 将全局tinymce对象指向给Vue作用域下
// Vue.use(VueTinymce)              // 安装vue的tinymce组件
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Video from 'video.js'
import 'video.js/dist/video-js.css'
Vue.prototype.$video=Video
import moment from 'moment'
import hevueImgPreview from 'hevue-img-preview'
Vue.use(hevueImgPreview)
Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    'inline': true,
    'button': true,
    'navbar': true,
    'title': true,
    'toolbar': true,
    'tooltip': true,
    'movable': true,
    'zoomable': true,
    'rotatable': true,
    'scalable': true,
    'transition': true,
    'fullscreen': true,
    'keyboard': true,
    'url': 'data-source'
  }
})

promise.polyfill()

Vue.config.productionTip = false

Vue.use(Element, {
  size: 'default',
  i18n: (key, value) => i18n.t(key, value)
})
Vue.use(EVueContextmenu)

Vue.prototype.$eventHub = Vue.prototype.$eventHub || new Vue()

// 挂载全局

Vue.prototype.$request = request
Vue.prototype.$validate = validate
Vue.prototype.$hasPermission = hasPermission
Vue.prototype.GLOBAL = global_
Vue.prototype.setStorage = setStorage
Vue.prototype.getStorage = getStorage
Vue.prototype.removeStorage = removeStorage
Vue.prototype.setLocalStorage = setLocalStorage
Vue.prototype.getLocalStorage = getLocalStorage
Vue.prototype.$echarts = echarts

Vue.prototype.timeoutLogout = () => {

  let timeout = new Date().getTime() + 1000 * 60 * 30
  var countTime = 0
  let userData = sessionStorage.getItem('v1user_data')
  let userId = '';
  if(userData != null){
    userId = JSON.parse(userData).userId
  }

  //console.log('start timeout')
  Vue.prototype.timeoutLogoutHandler = setInterval(function(){
    //console.log('auto logout timeout: ' + (timeout - countTime))
    countTime++
    let curTime = new Date().getTime()
    if (countTime % 20 == 0) {
      let when = moment(timeout).format('HH:mm')
      console.log(countTime + ' ' + when)
    }

    if( curTime >= timeout) {
      let token = sessionStorage.getItem('v1token')
      if (token != undefined && token != 'null' && token != '') {
        request.post('/auth/logoutIam', {userId: userId}).then((res) => {
          clearLoginInfo()
          this.hasLogin = false
          setStorage('logout_state', '1')
          clearInterval(Vue.prototype.timeoutLogoutHandler)
          router.push({ name: 'protalMain' })
          //router.replace({name: 'main'})
        })
      }
    }
  }, 1000)


}

// 保存整站vuex本地储存初始状态
window.SITE_CONFIG['storeState'] = cloneDeep(store.state)

new Vue({
  i18n,
  router,
  store,
  data: {
    eventHub: new Vue()
  },
  render: h => h(App)
}).$mount('#app')

Vue.component('chart')
// Vue.use(FullCalendar)
Vue.component('full-calendar', FullCalendar)

Vue.component('vue-ueditor-wrap', VueUeditorWrap)

// 提示消息只显示一条
let _message = Vue.prototype.$message
let _errorVisible = false
// type: success/warning/info/error
let proxyMessage = function (opt, type) {
  if (typeof (opt) === 'string') {
    let tmp = opt
    opt = {
      message: tmp
    }
    if (typeof (type) !== 'undefined') {
      opt.type = type
    } else {
      opt.type = 'info'
    }
  }
  let userOnClose = opt.onClose

  opt.onClose = function (obj) {
    _errorVisible = false
    _message.close(obj.id, userOnClose)
  }
  if (_errorVisible === false) {
    _errorVisible = true
    _message(opt)
  }
}

proxyMessage.success = function (opt) {
  proxyMessage(opt, 'success')
}

proxyMessage.warning = function (opt) {
  proxyMessage(opt, 'warning')
}

proxyMessage.info = function (opt) {
  proxyMessage(opt, 'info')
}

proxyMessage.error = function (opt) {
  proxyMessage(opt, 'error')
}

Vue.prototype.$message = proxyMessage
// 结束 提示消息只显示一条



